export const personalisedTabsMap = [
  {
    icon: 'https://acko-cms.ackoassets.com/car_fuel_personalised_90f8976920.svg',
    type: 'Car insurance',
    product: 'car',
    redirection_url: '/car-insurance/',
    backgroundColor: 'linear-gradient(161.3deg, #EFE9FB -2.04%, #F8F7FC 102.81%)',
  },
  {
    icon: 'https://acko-cms.ackoassets.com/bike_fuel_personalised_7c79b3243d.svg',
    type: 'Bike insurance',
    product: 'bike',
    redirection_url: '/two-wheeler-insurance/',
    backgroundColor: 'linear-gradient(161.3deg, #E2F5FF -2.04%, #F8F7FC 102.81%)',
  },
  {
    icon: 'https://acko-cms.ackoassets.com/health_fuel_personalised_ccf44eaf97.svg',
    type: 'Health insurance',
    product: 'health',
    redirection_url: '/health-insurance/',
    backgroundColor: 'linear-gradient(161.3deg, #FBE9F6 -2.04%, #F8F7FC 102.81%)',
  },
]
